module.exports = __webpack_public_path__ + "img/user-generated-content.78eb212a.svg";